<template>
  <v-card v-if="(contactId && contactInfo) || loadingContactInfo" class="" flat style="background: var(--card-back-accent)" @click.stop.prevent="() => {}">
    
    <template v-if="contactInfo">
      <div class="c-d-flex c-align-center pl-3 px-2" style="overflow-x: hidden">
        <v-icon color="white" class="pr-2" size="24">{{ contactInfo.registered ? '3p' : 'person' }}</v-icon>
        <div class="c-flex-grow-1 py-1">
          <div class="body-1">{{ contactInfo.fullName }}</div>
          <div class="body-2">{{ contactInfo.mobile }}</div>
        </div>
        <v-btn v-if="!expanded" :loading="loadingCustomFieldData" small icon flat color="white" class="pa-0 ma-0 mr-1" @click="showMore = !showMore">
          <v-icon>{{ showMore ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
        </v-btn>
      </div>
      
      <transition enter-active-class="scale-in-center" leave-active-class="scale-out-center" mode="out-in" >
        <div v-if="!loadingCustomFieldData && showMore" class="px-2 pt-1 pb-1">
          <app-contact-modify
              :custom-field-ref="customFieldRef"
              :value="contactInfo"
              class="px-1"
              @input="updateContact($event)"
          ></app-contact-modify>
        </div>
      </transition>
    </template>
    
    <div v-else class="pa-3 c-d-flex c-align-center c-justify-center">
      <v-progress-circular
          :size="40"
          :width="5"
          color="white"
          indeterminate
      ></v-progress-circular>
    </div>
  </v-card>
</template>

<script>
import AppContactModify from "@/contacts/AppContactModify.vue";

export default {
  components: {AppContactModify},
  props: {
    contactId: {
      type: [Number, String],
      default: 0
    },
    expanded: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loadingContactInfo: false,
      contactInfo: null,
      customFieldRef: new Map(),
      showMore: false,
      loadingCustomFieldData: false,
    }
  },
  mounted() {
    this.showMore = this.expanded;
  },
  watch: {
    contactId: {
      immediate: true,
      handler(val) {
        this.updateContactInfo()
      }
    },
    showMore: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadCustomFieldData()
        }
      }
    },
  },
  methods: {
    updateContact(updatedContact) {
      Object.assign(this.contactInfo, updatedContact)
    },
    
    async loadCustomFieldData() {
      try {
        this.loadingCustomFieldData = true
        const {customFields} = await this.$newReq('GET', `contacts/browse/startup`)
        this.customFieldRef = new Map(customFields.map(val => [val.id, val]))
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.loadingCustomFieldData = false
      }
    },
    
    async updateContactInfo() {
      try {
        this.contactInfo = null;
        this.loadingContactInfo = true
        if (!this.contactId) return
        const contactInfo = await this.$newReq('GET', `contacts/contactInfo/${this.contactId}`)
        this.$set(this, "contactInfo", contactInfo)
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.loadingContactInfo = false
      }
    },
  },
}
</script>


<style scoped>

</style>